// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ThvNh","question":"styles_question__E4NqA","description":"styles_description__2ePYW"};